import { SearchOff } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { COLORS } from "../../ui/Theme";

const NotFound = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Typography
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 0.5,
          color: COLORS.GRAY,
          fontSize: "14px",
        }}
      >
        <SearchOff sx={{ width: "20px" }} />
        محتوایی یافت نشد
      </Typography>
    </Box>
  );
};

export default NotFound;
